import { normalizeLegacyDeletedValue } from 'components/Search/functions';

/**
 * Converts editorial saved search payload to filter format for modal search.
 * Handles key mappings from saved search format to filter format and
 * transforms boolean values for advertorial and contributed fields.
 *
 * @param ssPayload - The saved search payload object
 * @param defaults - Optional default values for sort and dir
 * @returns Filters object ready to be applied to search context
 *
 */
export function convertSavedSearchToModalFilters(
  ssPayload: Record<string, any>,
  defaults?: { sort?: string; dir?: string },
): Record<string, any> {
  const filters: Record<string, any> = {};

  // Map saved search payload keys to filter keys
  const keyMap: Record<string, string> = {
    start_time_from: 'start_time[min]',
    start_time_to: 'start_time[max]',
    author_uuid: 'author',
    print_slug_slug: 'print_slug',
    'category[]': 'category',
    'type[]': 'type',
    'subject[]': 'subject',
  };

  Object.entries(ssPayload).forEach(([key, value]) => {
    const mappedKey = keyMap[key] || key;

    // Handle special boolean value mappings
    if (key === 'advertorial' || key === 'contributed') {
      if (value === 'exclude' || value === 'no' || value === false) {
        filters[mappedKey] = 'no';
      } else if (value === 'include' || value === 'yes' || value === true) {
        filters[mappedKey] = 'yes';
      }
    } else if (key === 'deleted') {
      const normalized = normalizeLegacyDeletedValue(value);
      if (normalized !== null && normalized !== undefined && normalized !== '') {
        filters[mappedKey] = normalized;
      }
    } else if (value !== null && value !== undefined && value !== '') {
      filters[mappedKey] = value;
    }
  });

  // Add default sort/dir if provided
  if (defaults?.sort) {
    filters.sort = filters.sort || defaults.sort;
  }
  if (defaults?.dir) {
    filters.dir = filters.dir || defaults.dir;
  }

  return filters;
}
